export const COMBAT_PLAYERBAR_PHASE = {
  LOADING: 'loading',
  ANNOUNCE: 'announce',
  // Combat PRELUDE — non-interactive opening-weakenings telegraph between Engage
  // and the first question (standalone HTN only). Mirrors BatchBossSession PHASE.
  PRELUDE: 'prelude',
  ANSWERING: 'answering',
  RESOLVING: 'resolving',
  ROUND_RESULT: 'round_result',
  REWARD: 'reward',
  WON: 'won',
  LOST: 'lost',
};

export function isCombatTerminalPhase(phase) {
  return phase === COMBAT_PLAYERBAR_PHASE.WON || phase === COMBAT_PLAYERBAR_PHASE.LOST;
}

// Met Heal action — Edward 2026-05-27. Allow during announce / answering /
// round_result (the "between-batches" feel). Block during loading, resolving
// (race window — combat is mid-mutation), reward, and terminal phases.
export function canTriggerHealAction(phase) {
  return (
    phase === COMBAT_PLAYERBAR_PHASE.ANNOUNCE
    || phase === COMBAT_PLAYERBAR_PHASE.ANSWERING
    || phase === COMBAT_PLAYERBAR_PHASE.ROUND_RESULT
  );
}
